import { Injectable } from '@angular/core';
import { DialogOptions } from '@examdojo/core/dialog';
import { QuestionHttpModel } from '@examdojo/models/question';
import { QuestionType } from '../review-item/review-item.model';
import { GenericQuestionHistoryDialogService } from './generic-question-history-dialog.service';

export interface DerivativeQuestionHistoryDialogInput {
  questionId: QuestionHttpModel['id'];
}

@Injectable({
  providedIn: 'root',
})
export class DerivativeQuestionHistoryDialogService {
  constructor(private readonly genericHistoryDialogService: GenericQuestionHistoryDialogService) {}

  openDialog({ input, options }: { input: DerivativeQuestionHistoryDialogInput; options?: DialogOptions }) {
    return this.genericHistoryDialogService.openDialog({
      input: {
        config: {
          questionId: input.questionId,
          questionType: QuestionType.Derivative,
          title: 'Derivative Question History',
        },
      },
      options,
    });
  }
}
